import _padStart from 'lodash/padStart';

export class User {
  exp: number;
  sub: string;
  pessoa: Pessoa;
  cpf: string;
  dataNascimento: number;
  rg: string;
  orgexp: string;
  tipoLogin: string;

  static sanitizarCpf(cpf: string): string {
    let tmp = cpf;
    if (tmp) {
      tmp = tmp.replace(/\D+/g, '');
    }
    tmp = _padStart(tmp, 11, '0');
    return tmp;
  }

  constructor(args) {
    Object.assign(this, args);
    this.cpf = User.sanitizarCpf(this.cpf);
  }
}

interface Pessoa {
  codigo: number;
  nome: string;
  email: string;
  ddd: string;
  celular: string;
  senha: string;
  isSenhaGerada: string;
  perfil: string;
}

interface Cidade {
  id: number;
  nome: string;
  estado: Estado;
}

interface Estado {
  nome: string;
  sigla: string;
}
